export const ITC_TABLE_DATA = 'boilerplate/Gstr2a2bNew/Itcregister/ITC_TABLE_DATA';
export const LOADER_STATUS = 'boilerplate/Gstr2a2bNew/Itcregister/LOADER_STATUS';
export const recoStatus = [
    {
    label: "All",
    value:'All',
    tagClassName: "special",
    checked: false,
    children: [
        {
            label: "Matched",
            value: "Matched",
          },
          {
            label: "Mismatched",
            value: "Mismatched",
          },
          {
            label: "Probable Match",
            value: "Probable Match",
          },
          {
            label: "Not in GSTN",
            value: "Not in GSTN",
          },
          {
            label: "Not in PR",
            value: "Not in PR",
          },
    ]
    }
];
export const markIn3b = [
    {
        label: "All",
        value:'All',
        tagClassName: "special",
        checked: false,
        children: [
    {
      label: "Yes",
      value: "Y",
    },
    {
      label: "No",
      value: "N",
    },
]
    }
];
